import { Lightbulb } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@components/ui/dialog';
import { AdGuide } from '@generated/components/AdGuide';

/** Always-available "What makes a great print ad" button for every Display Advertising step. */
export function AdGuideButton() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" className="fixed bottom-4 left-4 z-40 inline-flex min-h-12 items-center gap-2 whitespace-nowrap border-2 border-background bg-foreground px-5 text-sm font-black text-background shadow-[0_4px_14px_hsl(var(--foreground)/0.35)] hover:opacity-90 print:hidden">
          <Lightbulb className="h-5 w-5" />What makes a great ad?
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] w-[95vw] max-w-4xl overflow-y-auto rounded-none border-4 border-foreground p-0 sm:max-w-4xl">
        <DialogTitle className="sr-only">What makes a great print ad</DialogTitle>
        <div className="p-4 sm:p-6"><AdGuide defaultOpen /></div>
      </DialogContent>
    </Dialog>
  );
}
